<!-- 演讲嘉宾List -->
<template>
  <div class="guest-bg">
    <van-row justify="center">
      <van-col span="8" v-for="(item, index) in dateList" :key="index">
        <div class="guest-item" @click="showDetail(item)">
          <div class="guest-item-img">
            <van-image round fit="cover" width="88px" height="88px" :src="item.photo"></van-image>
          </div>
          <div class="guest-name">{{item.name}}</div>
          <div class="guest-company">{{item.company}}</div>
        </div>
      </van-col>
    </van-row>
    <van-overlay :show="show" @click="show = false" :lock-scroll="false">
      <div class="wrapper" @click.stop="show = false">
        <div class="pop-view" @click.stop>
          <div class="pop-header-view">
            <van-icon class="pop-close" name="cross" @click="show = false" />
            <div class="guest-item-img">
              <van-image round fit="cover" width="88px" height="88px" :src="popData.photo"></van-image>
            </div>
            <div class="pop-guest-name">{{popData.name}}</div>
            <div class="pop-guest-company">{{popData.company}}</div>
          </div>
          <p v-html="popData.description"></p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import config from '../../config/pageContent.js'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      show: false,
      popData: {},
      dateList: [],
      theme: 'dict'
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    showDetail(item) {
      this.popData = item;
      this.show = true;
    },
    getData() {
      var obj = config[this.theme];
      var exhibitionId = obj['exhibitionId'];
      var projectId = obj['projectId'];
      var params = {
        exhibitionId: exhibitionId,
        projectId: projectId
      }
      this.$http.getGuestList(params).then(res => {
        // 保存成功
        this.dateList = res.data.list;
      }).catch(error => {
        // console.log(error);
        // this.$Toast(error.data.message);
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    var theme = this.$route.query.theme ? this.$route.query.theme : 'dict';
    this.theme = theme;
    this.getData();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.guest-bg {
  min-height: calc(100vh);
  background-image: url('../../assets/guest-bg.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: #063A6B;
  padding-bottom: 24px;
}
.guest-item{
  text-align: center;
  margin-top: 24px;
  /* height: 169px; */
}
.guest-item-img {
  padding: 2px 0px;
  margin: 0 auto;
  width: 92px;
  height: 92px;
  background-image: url('../../assets/guest-border.png');
  background-repeat: no-repeat;
  background-size: 92px 92px;
  text-align: center;
}
.guest-name {
  padding-top: 6px;
  margin: 0 auto;
  width: 93px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.guest-company {
  padding-top: 4px;
  margin: 0 auto;
  width: 93px;
  font-size: 11px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #FFFFFF;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.pop-guest-name {
  padding-top: 6px;
  margin: 0 auto;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.pop-guest-company {
  padding-top: 4px;
  margin: 0 auto;
  font-size: 11px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
.pop-view {
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  position: relative;
  background-color: #FFFFFF;  
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  width: 320px;
  height: 426px;
  margin: 0 auto;
  padding: 20px 28px;
}
.pop-close {
  position: absolute;
  right: 12px;
  top: 12px;
}
.pop-header-view {
  text-align: center;
  margin-bottom: 16px;
}
</style>
